import * as angular from "angular";
import * as _ from "lodash";
import {getMetersPerLargeDistanceUnit} from "../utils/distance-unit.util";


angular
  .module('bringoz.admin.commons')
  .filter('priceByMeterToSiteDistance', priceByMeterToSiteDistance);

function priceByMeterToSiteDistance(splitService, $filter) {

  const distanceConfig = splitService.getSiteDistanceLargeUnit(true),
    factor = getMetersPerLargeDistanceUnit(distanceConfig === 'MI');

  return function bringozDistanceFilter(moneyPerMeter, showCurrency, defaultValue) {

    if (!_.isUndefined(moneyPerMeter)) {
      const value = (moneyPerMeter * factor).toFixed(1)
      return showCurrency ? $filter('bringozPrice')(value) : value;
    } else {
      return '---';
    }
  }
}
